import backend from '@common/backend';
import { ITableDataQuery } from '@common/models/TableData';
import { ICreateCgPartner } from '@common/types/api/cgPartnersTypes';

export const groupFromBE = (group: any) =>
	group
		? {
			...group,
			service: group.service_id,
			service_template: group.service_template_id,
		}
		: group;

const BASE = '/cgPartners';

export const getCgPartners = async (query: ITableDataQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const createCgPartners = async (data: ICreateCgPartner) => backend.post(`${BASE}`, data);

export const getCgPartner = async (id: number) => backend.get(`${BASE}/${id}`);

export const removeCgPartner = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveCgPartner = async (id: number, data: any) => backend.put(`${BASE}/${id}`, data);
